(() => {
  if (customElements.get('cft-creator-videos')) return;
  class CreatorVideos extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const rail = this.querySelector('.cft-creator-rail');
      const previous = this.querySelector('[data-cft-previous]');
      const next = this.querySelector('[data-cft-next]');
      const controls = this.querySelector('.cft-creator-controls');
      const update = () => {
        const maximum = rail.scrollWidth - rail.clientWidth;
        controls.hidden = maximum <= 2;
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= maximum - 2;
      };
      const move = direction => {
        const card = rail.querySelector('.cft-creator-card');
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        rail.scrollBy({left: direction * (card.offsetWidth + gap), behavior: 'instant'});
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      rail.addEventListener('scroll', update, options);
      rail.addEventListener('keydown', event => {
        if (event.target !== rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.addEventListener('play', event => {
        if (event.target.tagName !== 'VIDEO') return;
        this.querySelectorAll('video').forEach(video => {
          if (video !== event.target) video.pause();
        });
      }, {...options, capture: true});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(rail);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  }
  customElements.define('cft-creator-videos', CreatorVideos);
})();
